import api from "./api";

/* 获取主活动列表 */
export const mainActivityList = params => {
  return api('post', `/v1/management/combine-activity/list`, params);
};

/* 获取子活动列表 */
export const subActivityList = params => {
  return api('post', `/v1/management/combine-sub-activity/list`, params);
};

/* 新增主活动 */
export const addMainActivity = params => {
  return api('post', `/v1/management/combine-activity/add`, params);
};

/* 编辑主活动 */
export const editMainActivity = params => {
  return api('post', `/v1/management/combine-activity/edit`, params);
};

/* 主活动详情 get */
export const getMainActivityDetail = id => {
  return api('get', `/v1/management/combine-activity/detail/${id}`);
};

/* 发布主活动 */
export const publishMainActivity = id => {
  return api('post', `/v1/management/combine-activity/publish/${id}`);
};

/* 下架主活动 */
export const offlineMainActivity = id => {
  return api('post', `/v1/management/combine-activity/unpublish/${id}`);
};

/* 复制活动链接 */
export const copyActivityLink = id => {
  return api('get', `/v1/management/combine-activity/link/${id}`);
};

/* 生成签到码（subType=1 个人赛，subType=2 团队赛） */
export const generateCheckCode = (id, subType) => {
  return api('get', `/v1/management/combine-activity/qrcode/${id}`, { subType });
};

/* 主活动城市下拉列表 */
export const cityList = () => {
  return api('get', `/v1/management/combine-activity/cities`);
};

/* 子活动城市下拉列表 */
export const subActivityCityList = () => {
  return api('get', `/v1/management/combine-sub-activity/cities`);
};

/* 可选子活动列表 */
export const selectableSubActivities = (param) => {
  return api('post', `/v1/management/combine-activity/selectable-sub-activities`, param);
};

/* 子活动详情 */
export const getSubActivityDetail = id => {
  return api('get', `/v1/management/combine-sub-activity/detail/${id}`);
};

/* 新增子活动 */
export const addSubActivity = params => {
  return api('post', `/v1/management/combine-sub-activity/add`, params);
};

/* 编辑子活动 */
export const editSubActivity = params => {
  return api('post', `/v1/management/combine-sub-activity/edit`, params);
};

/* 删除子活动 */
export const deleteSubActivity = id => {
  return api('post', `/v1/management/combine-sub-activity/delete/${id}`);
};

/* 发布子活动 */
export const publishSubActivity = id => {
  return api('post', `/v1/management/combine-sub-activity/publish/${id}`);
};

/* 导出报名名单 */
export const exportSubActivity = eventId => {
  return api('get', `/v1/management/combine-sub-activity/export-enrollment/${eventId}`, {}, { responseType: 'blob' });
};

/* 导出身份证信息表 */
export const exportIdCard = eventId => {
  return api('get', `/v1/management/combine-sub-activity/export-id-card/${eventId}`, {}, { responseType: 'blob' });
};

/* 导出参赛码 */
export const exportCheckCode = eventId => {
  return api('get', `/v1/management/combine-sub-activity/export-code/${eventId}`, {}, { responseType: 'blob' });
};

/* combine 活动配置列表 */
export const combineActivityConfigList = params => {
  return api('post', `/v1/management/combine-equipment/list`, params);
};

/* combine 保存父活动商品配置 */
export const combineActivityConfigSave = params => {
  return api('post', `/v1/management/combine-equipment/saveEquipment`, params);
};

/* combine 查询父活动已关联商品 */
export const combineActivityConfigQuery = activityId => {
  return api('get', `/v1/management/combine-equipment/equipmentByActivityId/${activityId}`);
};

/* HHR 礼品登记信息列表 */
export const hhrGiftRegistrationList = params => {
  return api('post', `/v1/management/hhr-gift-registration/list`, params);
};

/* 导出 HHR 礼品登记信息 */
export const exportHhrGiftRegistration = () => {
  return api('get', `/v1/management/hhr-gift-registration/export`, {}, { responseType: 'blob' });
};
